import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="section-container bg-opacity-30">
      <div className="about-grid">
        <motion.div style={{
      marginLeft: '40px',
      marginRight: '40px'
    }} 
          className="about-content"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          
          <h2 className="section-title mb-8">{t('about.title')}</h2>
          
          <div className="about-text-wrapper">
            <p className="about-p main-p">{t('about.p1')}</p>
            <p className="about-p">{t('about.p2')}</p>
            <p className="about-p">{t('about.p3')}</p>
            <p className="about-p">{t('about.p4')}</p>
            <p className="about-p">{t('about.p5')}</p>
            
            
          </div>
        </motion.div>

        <motion.div 
          className="about-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <div className="image-stack">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/25fe57c277fc4d49baa2815a1646d92e367cb2ce89a7d2c278a4f8202228d92c658a999133b0fffe7649687a42276768/images/aW1hZ2UvanBlZw==/7164ca67c6c67683cf086318c61a892f.jpg" 
              alt="Workshop Expertise" 
              className="main-img glass-card"
            />
            <div className="accent-box" />
          </div>
        </motion.div>
      </div>

      <style jsx>{`
        .about-grid {
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 4rem;
          max-width: 1400px;
          margin: 0 auto;
          align-items: center;
        }

        .section-title {
          font-size: 3.5rem;
          font-weight: 800;
          line-height: 1.1;
        }

        .about-text-wrapper {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .about-p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #848489;
        }

        .main-p {
          font-size: 1.25rem;
          color: #DDDBE6;
          font-weight: 500;
        }

        .cta-highlight {
          padding: 1.5rem 2.5rem;
          border-left: 4px solid #8377BE;
          background: rgba(131, 119, 190, 0.05);
        }

        .about-visual {
          position: relative;
        }

        .image-stack {
          position: relative;
          z-index: 1;
        }

        .main-img {
          width: 100%;
          height: auto;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 20px 50px rgba(0,0,0,0.4);
        }

        .accent-box {
          position: absolute;
          top: -20px;
          right: -20px;
          width: 100px;
          height: 100px;
          background: var(--primary-gradient);
          border-radius: 20px;
          z-index: -1;
          opacity: 0.5;
        }

        @media (max-width: 1024px) {
          .about-grid {
            grid-template-columns: 1fr;
          }
          .about-visual {
            order: -1;
            max-width: 600px;
            margin: 0 auto 3rem;
          }
        }

        @media (max-width: 768px) {
          .section-title { font-size: 2.5rem; }
          .about-p { font-size: 1rem; }
          .main-p { font-size: 1.15rem; }
        }
      `}</style>
    </section>
  );
};

export default AboutSection;